module.exports = __webpack_public_path__ + "assets-cabinet/img/send-button.aad05ecd.svg";